import { create } from 'zustand';

/**
 * Ostatni adres **w aplikacji roboczej**, żeby „Wróć" z ustawień wracało tam, skąd
 * człowiek przyszedł.
 *
 * ⭐ Dlaczego to wystarcza, żeby być poprawne: zapisuje **wyłącznie `AppShell`**, a ta
 * powłoka nie renderuje się w ustawieniach (są osobną trasą, poza nią). Skoro więc
 * cokolwiek tu wpadło, to na pewno nie był ekran ustawień — nie ma potrzeby filtrować
 * ścieżek po prefiksie, czyli nie ma czego zapomnieć przy dołożeniu kolejnej sekcji.
 *
 * ⚠ Świadomie **efemeryczne** (nie `localStorage`): „wróć tam, gdzie byłem" dotyczy tej
 * wizyty. Po odświeżeniu przeglądarki człowiek nie pamięta, gdzie był przed ustawieniami,
 * więc udawanie, że pamięta program, byłoby udawaniem wiedzy.
 *
 * Zapas to pulpit — wejście prosto z linku (`/settings/teams` wklejone ze Slacka) nie ma
 * żadnego „skąd", a wyrzucanie człowieka na ekran, którego nie widział, byłoby gorsze niż
 * przewidywalny powrót na stronę główną.
 */
interface LastAppRouteState {
  path: string;
  remember: (path: string) => void;
}

export const useLastAppRoute = create<LastAppRouteState>((set) => ({
  path: '/',
  remember: (path) => set({ path }),
}));
